<template>
  <v-card-text class="mt-2 mb-2" id="v-card__title" >
    <v-row no-gutters >
      <v-col cols="12" class="d-flex search-margin-top" id="col" >
        <v-select
          v-model='editedItem.locationSelectedFilterId'
          :items='locationFilterOptions'
          class="searchFilterDropDown ma-0 pa-0 noselect"
          dense
          solo
          @change="onFilterChange"
          background-color= "#0B5940"
          color="#FFF"
          dark
          hide-details
        ></v-select>
        <v-autocomplete
          @keyup="onTextSearch"
          v-model="editedItem.textSearchObject"
          :loading='isLoading'
          :items='searchList'
          item-value='id'
          :placeholder='placeHolderText'
          append-icon='mdi-magnify'
          color='information'
          return-object
          background-color= "searchbgColor search-height"
          @change="onChangeTextSearch"
          class="search-pad mainSearch ma-0 pa-0"
          clearable
          :filter="v => v"
          :no-data-text='noDataText'
          hide-details
        >
          >
          <template v-slot:item='{parent, item}'>
            <template>
              <v-list-item-content>
                <v-list-item-title v-if="!item.postalCode" v-html="item.name"></v-list-item-title>
                <v-list-item-title v-else-if="item.postalCode" v-html="item.name + ' - ' + item.postalCode.toString()"></v-list-item-title>
                <v-list-item-subtitle>
                  <template v-if="item.level === '4'">{{ item.countyName }}, </template>
                  <template v-if="item.level != '1' && item.level != '6'">{{ item.stateAbbreviation }}, </template>
                  <template>{{ item.countryAbbreviation }}</template>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
        <Geolocationmarker v-if="this.isHomePage || $vuetify.breakpoint.width > 600" ></Geolocationmarker>
      </v-col>
<!--      <v-col cols="1" class="pa-0 ma-0 text-center" >-->
<!--        -->
<!--      </v-col>-->
    </v-row>
  </v-card-text>
</template>

<script>
import Geolocationmarker from './Geolocationmarker'
import { _ } from 'vue-underscore'
import CONSTANTS from '../../../config/constant'
export default {
  components: {
    Geolocationmarker
  },
  data: () => ({
    placeHolderText: 'Search for a country, state, county, jurisdiction, township or zip-code to view adoptions',
    locationFilterOptions: CONSTANTS.SEARCH_FILTERS,
    noDataText: 'Start typing to view results',
    isLoading: false,
    valid: false,
    keyCode: [37, 38, 39, 40],
    loadingSearch: false,
    searchIconClicked: false,
    stateName: '/',
    countyName: '',
    jurisdictionName: '',
    townshipName: '',
    item: [],
    editedItem: {
      locationSelectedFilterId: CONSTANTS.SEARCH_FILTERS_DEFAULT,
      textSearch: '',
      textSearchObject: {},
      stateObject: {},
      countyObject: {},
      countryId: '',
      stateId: '',
      countyId: '',
      jurisdictionObject: {},
      jurisdictionId: '',
      townshipId: ''
    },
    defaultItem: {
      textSearch: '',
      stateObject: {},
      countyObject: {},
      countryId: '',
      stateId: '',
      countyId: '',
      jurisdictionObject: {},
      jurisdictionId: '',
      townshipId: ''
    },
    ico: {
      icon: 'mdi-chevron-down',
      'icon-alt': 'mdi-close',
      model: true
    }
  }),
  props: {
    isHomePage: Boolean
  },
  mounted () {
    this.$store.commit('FESearchModule/setTextSearchList', [])
    this.onTextSearch = _.debounce(this.onTextSearch, 350)
  },
  computed: {
    searchList () {
      let returnItems = []
      const searchItems = this.$store.getters['FESearchModule/fetchTextSearchList']
      if (searchItems) {
        if (searchItems.countries && searchItems.countries.length > 0) {
          if (this.editedItem.locationSelectedFilterId === CONSTANTS.SEARCH_FILTERS_DEFAULT) {
            returnItems.push({ header: 'countries' })
          }
          returnItems.push(...searchItems.countries)
          if ((searchItems.countries && searchItems.countries.length > 0)) {
            returnItems.push({ divider: true })
          }
        }
        if (searchItems.states && searchItems.states.length > 0) {
          if (this.editedItem.locationSelectedFilterId === CONSTANTS.SEARCH_FILTERS_DEFAULT) {
            returnItems.push({ header: 'states' })
          }
          returnItems.push(...searchItems.states)
          if ((searchItems.counties && searchItems.counties.length > 0) || (searchItems.jurisdictions && searchItems.jurisdictions.length > 0)) {
            returnItems.push({ divider: true })
          }
        }
        if (searchItems.counties && searchItems.counties.length > 0) {
          if (this.editedItem.locationSelectedFilterId === CONSTANTS.SEARCH_FILTERS_DEFAULT) {
            returnItems.push({ header: 'counties' })
          }
          returnItems.push(...searchItems.counties)
          if (searchItems.jurisdictions && searchItems.jurisdictions.length > 0) {
            returnItems.push({ divider: true })
          }
        }
        if (searchItems.jurisdictions && searchItems.jurisdictions.length > 0) {
          if (this.editedItem.locationSelectedFilterId === CONSTANTS.SEARCH_FILTERS_DEFAULT) {
            returnItems.push({ header: 'jurisdictions' })
          }
          returnItems.push(...searchItems.jurisdictions)
        }
        if (searchItems.townships && searchItems.townships.length > 0) {
          if (this.editedItem.locationSelectedFilterId === CONSTANTS.SEARCH_FILTERS_DEFAULT) {
            returnItems.push({ header: 'townships' })
          }
          returnItems.push(...searchItems.townships)
        }
      }
      return returnItems
    }
  },
  methods: {
    // on click of search button
    onSearchClick () {
      const selectedData = this.editedItem.textSearchObject
      const formData = {
        countryId: selectedData.countryId,
        stateId: selectedData.stateId,
        jurisdictionId: selectedData.jurisdictionId,
        townshipId: selectedData.townshipId,
        countyId: selectedData.countyId
      }
      if (formData.countryId !== '' || formData.stateId !== '' || formData.jurisdictionId !== '' || formData.countyId !== '' || formData.townshipId !== '') {
        this.loadingSearch = true
        // Reset back code adoption selected text to current
        this.$emit('defaultAdoptionItems', 'Current')
        if (this.countyName === '' && this.jurisdictionName === '') {
          this.stateName = this.stateName !== '' ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
        } else if (this.countyName !== '' && this.jurisdictionName === '' && this.townshipName === '') {
          this.stateName = this.stateName !== '' ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
          this.countyName = this.countyName.replace(/\s+/g, '-').toLowerCase()
        } else if (this.countyName === '' && this.jurisdictionName !== '' && this.townshipName === '') {
          this.stateName = this.stateName !== '' ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
          this.jurisdictionName = this.jurisdictionName.replace(/\s+/g, '-').toLowerCase()
        } else if (this.stateName !== '' && this.jurisdictionName === '' && this.townshipName === '') {
          this.stateName = this.stateName !== '' ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
        } else if (this.stateName !== '' && this.countyName !== '' && this.townshipName !== '' && this.townshipName !== undefined) {
          this.stateName = this.stateName !== '' ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
          this.countyName = this.countyName !== '' && this.countyName !== null ? this.countyName.replace(/\s+/g, '-').toLowerCase() : ''
          this.townshipName = this.townshipName !== '' && this.townshipName !== null ? this.townshipName.replace(/\s+/g, '-').toLowerCase() : ''
        } else if (this.countryName) {
          this.countryName = this.countryName ? this.countryName.replace(/\s+/g, '-').toLowerCase() : ''
        } else {
          this.stateName = this.stateName !== '' && this.stateName !== null ? this.stateName.replace(/\s+/g, '-').toLowerCase() : ''
          this.jurisdictionName = this.jurisdictionName !== '' && this.jurisdictionName !== null ? this.jurisdictionName.replace(/\s+/g, '-').toLowerCase() : ''
          this.countyName = this.countyName !== '' && this.countyName !== null ? this.countyName.replace(/\s+/g, '-').toLowerCase() : ''
          this.townshipName = this.townshipName !== '' && this.townshipName !== null && this.townshipName !== undefined ? this.townshipName.replace(/\s+/g, '-').toLowerCase() : ''
          this.countryName = this.countryName ? this.countryName.replace(/\s+/g, '-').toLowerCase() : ''
        }

        const isCallFromHomePage = (typeof this.isHomePage !== 'undefined' && this.isHomePage) ? !this.isHomePage : false
        this.loadingSearch = false
        this.$store.commit('FESearchModule/setCheckBookMarkSearchAPI', isCallFromHomePage)
        let adoptionLevel = ''
        if (this.stateName !== '' && this.stateName !== undefined) {
          adoptionLevel = 1
        }
        if (this.countyName !== '' && this.countyName !== undefined) {
          adoptionLevel = 2
        }
        if (this.jurisdictionName !== '' && this.jurisdictionName !== undefined) {
          adoptionLevel = 3
        }
        if (this.townshipName !== '' && this.townshipName !== undefined) {
          adoptionLevel = 4
        }
        if (this.countryName !== '' && this.countryName !== undefined) {
          adoptionLevel = 6
        }
        switch (adoptionLevel) {
          case 1:
            this.$router.push({ name: 'StateCodeAdoption', params: { countryName: 'usa', stateName: this.stateName, locateMe: true } })
            this.editedItem.textSearchObject = {}
            this.onCloseClick()
            break
          case 2:
            this.$router.push({ name: 'CountyCodeAdoption', params: { countryName: 'usa', stateName: this.stateName, countyName: this.countyName, locateMe: true } })
            this.editedItem.textSearchObject = {}
            this.onCloseClick()
            break
          case 3:
            this.$router.push({ name: 'JurisdictionCodeAdoption', params: { countryName: 'usa', stateName: this.stateName, jurisdictionName: this.jurisdictionName, locateMe: true } })
            this.editedItem.textSearchObject = {}
            this.onCloseClick()
            break
          case 4:
            this.$router.push({ name: 'TownshipCodeAdoption', params: { countryName: 'usa', stateName: this.stateName, countyName: this.countyName, townshipName: this.townshipName, locateMe: true } })
            this.editedItem.textSearchObject = {}
            this.onCloseClick()
            break
          case 6:
            if (selectedData.countryAbbreviation === CONSTANTS.DEFAULT_COUNTRY_NAME) {
              this.$router.push({ name: 'Home', params: { locateMe: true, pageId: true } })
            } else {
              this.$router.push({ name: 'WorldCodeAdoption', params: { countryName: this.countryName, locateMe: true } })
            }
            this.editedItem.textSearchObject = {}
            this.onCloseClick()
            break
        }
      }
    },
    onCloseClick () {
      Object.assign(this.editedItem, this.defaultItem)
      this.searchIconClicked = true
      this.ico.model = true
      this.$store.commit('FESearchModule/setTextSearchList', [])
    },
    onFilterChange () {
      this.$store.commit('FESearchModule/setTextSearchList', [])
      this.noDataText = 'Start typing to view results'
      const filterValue = this.editedItem.locationSelectedFilterId
      switch (filterValue) {
        case CONSTANTS.SEARCH_FILTERS_DEFAULT:
          this.placeHolderText = 'Search for a country, state, county, jurisdiction, township or zip-code to view adoptions'
          break
        case 'State':
          this.placeHolderText = 'Search for a state to view adoptions'
          break
        case 'County':
          this.placeHolderText = 'Search for a county to view adoptions'
          break
        case 'Jurisdiction':
          this.placeHolderText = 'Search for a jurisdiction or zip-code to view adoptions'
          break
        case 'Township':
          this.placeHolderText = 'Search for a township or zip-code to view adoptions'
          break
        case 'Country':
          this.placeHolderText = 'Search for a country to view adoptions'
          break
        default:
          this.placeHolderText = 'Search for a state, county, jurisdiction, township or zip-code to view adoptions'
      }
    },
    onTextSearch (event) {
      const keyCode = this.keyCode
      this.isLoading = true
      const searchString = event.target.value
      if (searchString.length >= 3) {
        if (!keyCode.includes(event.keyCode)) {
          // get the value of filter drop down, default value is All Locations
          let filterId = 5
          switch (this.editedItem.locationSelectedFilterId) {
            case CONSTANTS.SEARCH_FILTERS_DEFAULT:
              filterId = 5
              break
            case 'State':
              filterId = 1
              break
            case 'County':
              filterId = 2
              break
            case 'Jurisdiction':
              filterId = 3
              break
            case 'Township':
              filterId = 4
              break
            case 'Country':
              filterId = 6
              break
            default:
              filterId = 5
          }
          new Promise((resolve, reject) => {
            this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
          }).then((tokenData) => {
            let tokens = tokenData.data
            this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
              new Promise((resolve, reject) => {
                this.$store.dispatch('FESearchModule/textSearch', {
                  resolve,
                  reject,
                  searchString,
                  filterId
                })
              })
                .then(responseData => {
                  this.isLoading = false
                  const searchItems = this.$store.getters['FESearchModule/fetchTextSearchList']
                  if ((searchItems.states && searchItems.states.length <= 0) && (searchItems.counties && searchItems.counties.length <= 0) && (searchItems.jurisdictions && searchItems.jurisdictions.length <= 0) && (searchItems.townships && searchItems.townships.length <= 0) && (searchItems.countries && searchItems.countries.length <= 0)) {
                    this.noDataText = 'No record found for your search'
                    this.$store.commit('FESearchModule/setTextSearchList', [])
                  }
                })
                .catch(response => {
                  this.isLoading = false
                  this.noDataText = 'Start typing to view results'
                  this.$store.commit('FESearchModule/setTextSearchList', [])
                  // add loader on button if required
                })
            }).catch()
          }).catch()
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$store.commit('FESearchModule/setTextSearchList', [])
        this.noDataText = 'Start typing to view results'
      }
    },
    onChangeTextSearch () {
      if (this.editedItem && this.editedItem.textSearchObject) {
        const selectedData = this.editedItem.textSearchObject
        this.stateId = selectedData.stateId
        this.stateName = selectedData.stateName
        this.countyId = selectedData.countyId
        this.countyName = selectedData.countyName
        this.jurisdictionId = selectedData.jurisdictionId
        this.jurisdictionName = selectedData.jurisdictionName
        this.townshipId = selectedData.townshipId
        this.townshipName = selectedData.townshipName
        this.countryId = selectedData.countryId
        this.countryName = selectedData.countryName
        this.onSearchClick()
      }
      this.onCloseClick()
    }
  }
}
</script>
